// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import Vant from 'vant'
// import { Loading } from 'vant';
// import 'vant/lib/loading/style';
// import { Tab, Tabs, Popup , Toast } from 'vant';
// import 'vant/lib/tab/style';
// import 'vant/lib/tabs/style';
// import 'vant/lib/popup/style';
// import 'vant/lib/toast/style';
import 'vant/lib/index.css';
import axios from 'axios'

Vue.use(Vant)

// 配置axios默认设置，处理跨域和重定向问题
axios.defaults.withCredentials = false; // 不发送cookies
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.maxRedirects = 0; // 禁止自动重定向

// 由于服务器存在CORS问题，使用Vue.prototype.$axios而不是直接axios
Vue.prototype.$axios = axios
// Vue.use(Toast);
// Vue.use(Loading);
// Vue.use(Popup);
// Vue.use(Tab);
// Vue.use(Tabs);
Vue.use(ElementUI);
Vue.use(Viewer, {
    defaultOptions: {
        zIndex: 9999
    }
})
Viewer.setDefaults({
    // 工具栏按钮的控制
    toolbar: {
        zoomIn: 1, // 放大
        zoomOut: 1, // 缩小
        oneToOne: 1, // 100%大小
        reset: 1, // 还原
        prev: 0, // 上一张
        play: 1, // 全屏显示
        next: 0, // 下一张
        rotateLeft: 1, // 逆时针旋转
        rotateRight: 1, // 顺时针旋转
        flipHorizontal: 1, // 水平翻转
        flipVertical: 1 // 垂直翻转
    }
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js